import { createContext } from 'react';
export var LayerListContext = createContext({
    selectedIds: [],
    expandedMap: {},
    itemsMap: {},
    filter: { filterText: '', filteredItems: {} },
    setIsExpandedLayer: function () { return null; },
});
